module.exports = __webpack_public_path__ + "img/github.0c83fd0d.svg";